import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import ProjectService from '../../../services/ProjectService'

type DeleteProjectPayload = {
  organization: string
  name: string
}

export const useDeleteProject = () => {
  const { org } = useParams()
  const queryClient = useQueryClient()

  return useMutation<any, Error, DeleteProjectPayload>({
    mutationKey: ['delete-project'],
    mutationFn: ({ organization, name }) => ProjectService.deleteProject(organization, name),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['projects', org] })
      queryClient.invalidateQueries({ queryKey: ['projects-structure'] })
    },
  })
}
